/** Stands in for `src/utils/time.ts` of the reference implementation, which is not needed here. */
export function nowIso(): string {
  return new Date().toISOString();
}
